// extracted by mini-css-extract-plugin
export default {"portfolioNav":"PortfolioNav_portfolioNav__Jo3C7"};